import { regClientResponse, regRoundResponse, regStepResponse } from "./Csi/csi.types";
import { api_107 } from "./1.07/rgs.107";
import { api_108 } from "./1.08/rgs.108";
import { getCheatFromSelectedMode } from "./utils/utilsMethod";
import { getGameInstance, startGame } from "./Start";
import { Formatter } from "./utils/formatter";
import { allListener } from "./utils/listener";

export class api_base{
    public clientUid: any;
    public clientTokenForRequest: any;
    public rgs: api_107 | api_108;

    protected gn_data: any = null;

    private coin : number = 0;
    private level : number = 0;
    private betMap: any = null;
    private increment : any = 0;

    private isPossibleRefreshBalance = false //Mentre sei in partita non sarà possibile aggiornare il balance
    private serverApi: string = "";

    private game; 

    /**
     * Constructor
     * @param gameKey                Game Key
     * @param gameUID                Game UID
     * @param params                 Objects params
     * @param httpMonitorCallback    Monitoring Callback
     */
    constructor(gameKey: string, params: any, clientUID: any, clientTokenForRequest: any) {
        console.log("✅=^.^= Peppes Libs is connected successfullyy!");
        
        this.clientUid = clientUID;
        this.clientTokenForRequest = clientTokenForRequest;
        this.game = getGameInstance();
        this.serverApi=params.serverAPI.substr(0,4)

        // TODO: modificare per renderlo compatibile con la 1.06, 1.08 e la 2.00
        // NOTA: si utilizzano i primi 4 caratteri al fine di gestire eventuali versioni di test/sviluppo (ad esempio 1.07-DEV) 
        switch (params.serverAPI.substr(0,4)) {
            //case "1.06":
            //    this.rgs = new rgs.api_106(gameKey, gameUID, params, httpMonitorCallback);
            //    break;
            case "1.07":
                this.rgs = new api_107(gameKey, params.game, params, this.game);
                break;
            //case "2.00":
            //    this.rgs = new rgs.api_107(gameKey, gameUID, params, httpMonitorCallback); 
            //    break;
            case "1.08":
                this.rgs = new api_108(gameKey, params.game, params, this.game);
                break;
            }
        
        if (this!.rgs == null) {
            throw new Error("RGS API Unavailable");
        }
        
        allListener(this.game, this);

    }
    
    public getCoin(): number {
        return this.coin;
    }

    public getLevel(): number {
        return this.level;
    }

    public setParams(clientUID: any, clientTokenForRequest: any, betMap: any){
        this.clientUid = clientUID;
        this.clientTokenForRequest = clientTokenForRequest;

        //è la prima betmap alla regClient
        this.betMap = betMap;
    }

    public getBetMap(){
        this.betMap[0].coins = this.coin;
        this.betMap[0].value = this.coin;
        this.betMap[0].total = (this.level * this.coin);
    }

    private extractApiErrorCode(value: any): number | null {
        if (value == null) {
            return null;
        }

        if (typeof value === 'string') {
            try {
                const parsed = JSON.parse(value);
                return this.extractApiErrorCode(parsed);
            } catch {
                const directMatch = value.match(/"e"\s*:\s*(\d+)/);
                if (directMatch) {
                    return Number(directMatch[1]);
                }

                const legacyMatch = value.match(/code\s*[:=]\s*(\d+)/i);
                return legacyMatch ? Number(legacyMatch[1]) : null;
            }
        }

        if (typeof value !== 'object') {
            return null;
        }

        const directCode = (value as any).e;
        if (typeof directCode === 'number' && Number.isFinite(directCode)) {
            return directCode;
        }

        if (typeof directCode === 'string' && /^\d+$/.test(directCode)) {
            return Number(directCode);
        }

        const candidates = [
            (value as any).response?.data,
            (value as any).response,
            (value as any).data,
            (value as any).error,
            (value as any).reason,
            (value as any).cause,
            (value as any).message,
        ];

        for (const candidate of candidates) {
            const code = this.extractApiErrorCode(candidate);
            if (code !== null) {
                return code;
            }
        }

        return null;
    }

    private async handleRgsCallError(error: unknown, context: string): Promise<Error> {
        const e = error instanceof Error ? error : new Error(String(error));
        const errorCode = this.extractApiErrorCode(error) ?? 20001;

        // Evita popup duplicati: il listener globale salterà gli errori già gestiti qui.
        (e as any).__rgsPopupHandled = true;

        console.error(`❌ Errore in ${context}:`, e.message, e.stack);

        const payload = {
            m: e.message,
            stack: e.stack,
            clientUid: this.clientUid
        };

        this.rgs.transport.stopClientTimeout();
        (window as any).UIBridge?.showAll?.();
        (window as any).UIBridge.showPopupErrorMessage(`popup.genericMessage`, errorCode, true, (window as any).GENERAL_CONFIG.onlyRedirectToHomeOnNetworkError, false, true);
        await this.rgs.logEventAsync(32000, payload, null, this.clientUid, this.clientTokenForRequest);

        return e;
    }

    //Chiamata al motore di gioco
    public async regClient(params: any) : Promise<regClientResponse> {
        this.isPossibleRefreshBalance = false
        try {
            const sessionResponse = await this.rgs.getSessionAsync(params);

            const response = await this.rgs.regClientAsync(params);
            this.clientTokenForRequest = response.clientToken

            this.level = response.data.b?.[0]?.l ?? response.data.initialBets?.[0]?.level ?? 0;
            this.coin = response.data.b?.[0]?.c ?? response.data.initialBets?.[0]?.coin ?? 0;

            this.increment = response.data.b?.[0]?.i ?? response.data.initialBets?.[0]?.incrementLevel ?? 0;
            //INITIAL BET DEVO METTERE QUA L'INCREMENT

            (window as any).UIBridge?.setBetCoins(this.coin); 
            (window as any).UIBridge?.setCoinText((window as any).FORMATTER.formatCurrency(this.coin, true));
            (window as any).UIBridge?.setBet((window as any).FORMATTER.formatCurrency(this.level * this.coin, true)); 
            (window as any).UIBridge?.setBetIncrements(Number(this.increment));
            (window as any).UIBridge?.setIncrementText(this.increment);
          
            this.isPossibleRefreshBalance = true
            this.keepAliveStart();
            this.balancePingStart();
            return response;
        } catch (error) {
            throw await this.handleRgsCallError(error, 'Caller.regClient');
        }
    }
    
    //Chiamata al motore di gioco
    public async regRound(mode: number, data?: object, bet?: any, cheat?: object): 
    Promise<regRoundResponse> {
        console.log("📞 CALLER.regRound chiamato!");
        this.isPossibleRefreshBalance = false
        this.getBetMap();
        bet = this.betMap;
    
        try {
            const response = await this.rgs.regRoundAsync(true, bet, this.gn_data, this.clientUid, this.clientTokenForRequest, cheat); //aggiungere enabledgambleround
            this.clientTokenForRequest = response.token
            console.log("✅ Risposta reg_round ricevuta:", response);
            return response;
        } catch (error) {
            throw await this.handleRgsCallError(error, 'Caller.regRound');
        }
    }
    
    //Chiamata al motore di gioco
    public async regStep(mode: number, data?: object, bet?: any, cheat?: object): 
    Promise<regStepResponse> {
        console.log("📞 CALLER.regStep chiamato!");

        this.isPossibleRefreshBalance = false
        if(!cheat) {
            cheat = getCheatFromSelectedMode();
        }

        try {
            const response = await this.rgs.regStepAsync(mode, bet, data, this.gn_data, cheat, this.clientUid, this.clientTokenForRequest);
            
            cheat = undefined;
            (window as any).UIBridge?.resetCheat()
            
            this.clientTokenForRequest = response.token
            console.log("✅ Risposta reg_step ricevuta:", response);
            
            //await this.endStep();
    
            return response;
        } catch (error) {
            throw await this.handleRgsCallError(error, 'Caller.regStep');
        }
    }

    public async gameAnimationStart(): Promise<void> {
        console.log("🎬 gameAnimationStart nelle lib"); 
    }

    
    public async gameAnimationComplete(gameCanvas: HTMLCanvasElement): Promise<void> {
        // Se vuoi loggare:
        console.log("📞 CALLER.gameAnimationComplete chiamato!");
    
        // Dispatch degli eventi solo se il canvas è valido
        if (gameCanvas) {
            const event1 = new Event('gameAnimationComplete');
            gameCanvas.dispatchEvent(event1);
    
            const event2 = new Event('gcmGameAnimationComplete');
            gameCanvas.dispatchEvent(event2);
        }
        
        // Se hai bisogno di restituire qualcosa:
        return;
    }

    //Chiamata al motore di gioco
    public async endRound() : Promise<void> {
        if(this.serverApi === "1.08") {
            try {
                const response = await this.rgs.endRound(this.clientTokenForRequest);
                this.clientTokenForRequest = response.t;
                this.isPossibleRefreshBalance = true;
            } catch (error) {
                throw await this.handleRgsCallError(error, 'Caller.endRound');
            }
        } else {
            return Promise.resolve(); // Se non è 1.08, non fare nulla e risolvi la promessa
        }

    }

    //Chiamata al motore di gioco
    public async endStep(){
        if(this.serverApi === "1.08") {
            try {
                const response = await this.rgs.endStep(this.clientTokenForRequest);
                this.clientTokenForRequest = response.t;
            } catch (error) {
                throw await this.handleRgsCallError(error, 'Caller.endStep');
            }
        } else {
            return Promise.resolve(); // Se non è 1.08, non fare nulla e risolvi la promessa
        }
    }

    public async refreshBalance(){
        if (!this.isPossibleRefreshBalance) {
            return;
        }

        try {
            await this.rgs.getDataAsync()
        } catch (error) {
            throw await this.handleRgsCallError(error, 'Caller.refreshBalance');
        }
    }

    public keepAliveStart(){
        this.rgs.keepAlivePingStart();
    }

    public keepAliveStop(){
        this.rgs.keepAlivePingStop();
    }
    
    public balancePingStart(){
        this.rgs.requestBalancePingStart();
    }

    public balancePingStop(){
        this.rgs.requestBalancePingStop();
    }
}